import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackSearchApps = (query, results = null) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    search_query: query,
    search_type: 'app_discovery',
    query_length: query.length,
    has_results: results ? results.hasGoodMatches : null,
    ...getEnvironmentData()
  };

  posthog.capture('app_search', eventData);
  track('app_search', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('Search', {
      search_string: query,
      content_type: 'product',
      content_name: 'app_discovery',
      content_id: 'search_apps'
    });
  }
}; 